const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const getAllMessages = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_MESSAGE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_MESSAGE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getAllMessages;